import React from "react";
import { MessageCircle, ChevronRight } from "lucide-react";
import { Card, CardContent } from "./ui/card";



const DiscussionForumBlock: React.FC = () => {

const handleClick = () => {
  console.log('Discussion forum clicked!');
  const forumUrl = process.env.REACT_APP_DISCOURSE_FORUM_URL || 'https://forum.commandlegacy.us';
  window.open(forumUrl, '_blank');
};
  return (
<Card className="bg-slate-800 border-l-4 border-command-green rounded-xl cursor-pointer hover:bg-slate-700 transition-colors" onClick={handleClick}>      <CardContent className="p-6">
        <div className="space-y-4">
          {/* Row 1: Icon + Title + Description */}
          <div className="flex items-start space-x-4">
            <div className="bg-command-green/30 p-2 rounded-full mt-3">
              <MessageCircle className="h-8 w-8 text-command-green/90" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-white">Discussion Forum</h3>
              <p className="text-white/70 text-sm">
                Connect with law enforcement professionals
              </p>
            </div>
          </div>

          {/* Row 2: Three bullet points in 3 columns */}
          <div className="w-full flex flex-row items-center justify-between">
            <div className="text-white/50 text-xs">• 0 Active Topics</div>
            <div className="text-white/50 text-xs">• Expert Discussions</div>
            <div className="text-white/50 text-xs flex items-center">
              Best Practices <ChevronRight className="h-4 w-4 ml-1" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DiscussionForumBlock;
